class TouristRouteStopsApiResponseModel {
  // #region Props

  // #endregion
  constructor({
    nombre,
    descripcion,
    fiesta,
    fotoUrl,
    id}) {
    return {
      nombre,
      descripcion,
      fiesta,
      fotoUrl,
      id,
    };
  }
}

export default TouristRouteStopsApiResponseModel;
